import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { URLS, Url } from '@wix/da-url';
import { BiEventType } from '../../../../biLogger/constants';
import { ModalType } from '../../../../Modals/redux/types';
import MobileSubmitMenuItem from '../../../_partials/MobileSubmitMenuItem';
import s from './SubmitMenu.scss';
var SubmitMenu = function (_a) {
    var isLegacyHeader = _a.isLegacyHeader, pushModal = _a.pushModal, isOpen = _a.isOpen;
    var t = useTranslation().t;
    var submitMenuItems = useMemo(function () { return [
        {
            key: 'siteHeader.deviation',
            url: URLS.SUBMIT,
            verificationAction: 'submit',
            biData: {
                evid: BiEventType.TOP_NAV_MENU_CLICK,
                menu_item: 'deviation',
                menu_name: 'submit',
                link_url: URLS.SUBMIT,
            },
        },
        {
            key: 'siteHeader.statusUpdate',
            verificationAction: 'submitstatus',
            biData: {
                evid: BiEventType.TOP_NAV_MENU_CLICK,
                menu_item: 'status',
                menu_name: 'submit',
                link_url: isLegacyHeader
                    ? Url.browseHomeLink() + "?submit_modal=status"
                    : undefined,
            },
            url: isLegacyHeader
                ? Url.browseHomeLink() + "?submit_modal=status"
                : undefined,
            onClick: isLegacyHeader
                ? undefined
                : function () { return pushModal(ModalType.STATUS_UPDATE, { wrapInModal: false }); },
        },
        {
            key: 'siteHeader.poll',
            verificationAction: 'submitpoll',
            biData: {
                evid: BiEventType.TOP_NAV_MENU_CLICK,
                menu_item: 'status',
                menu_name: 'poll',
                link_url: isLegacyHeader
                    ? Url.browseHomeLink() + "?submit_modal=poll"
                    : undefined,
            },
            url: isLegacyHeader
                ? Url.browseHomeLink() + "?submit_modal=poll"
                : undefined,
            onClick: isLegacyHeader
                ? undefined
                : function () { return pushModal(ModalType.POLL_EDIT, { wrapInModal: false }); },
        },
        {
            key: 'siteHeader.commission',
            verificationAction: 'submitcommission',
            biData: {
                evid: BiEventType.TOP_NAV_MENU_CLICK,
                menu_item: 'commission',
                menu_name: 'submit',
                link_url: isLegacyHeader
                    ? Url.browseHomeLink() + "?submit_modal=commission"
                    : undefined,
            },
            url: isLegacyHeader
                ? Url.browseHomeLink() + "?submit_modal=commission"
                : undefined,
            onClick: isLegacyHeader
                ? undefined
                : function () {
                    return pushModal(ModalType.COMMISSION, {
                        wrapInModal: false,
                        params: {
                            redirectOnSubmit: true,
                        },
                    });
                },
        },
    ]; }, [isLegacyHeader, pushModal]);
    return (React.createElement("ul", { className: s['root'], "aria-hidden": !isOpen }, submitMenuItems.map(function (_a) {
        var key = _a.key, url = _a.url, verificationAction = _a.verificationAction, biData = _a.biData, onClick = _a.onClick;
        return (React.createElement("li", { className: s['menu-item'], key: key },
            React.createElement(MobileSubmitMenuItem, { url: url, verificationAction: verificationAction, onClick: onClick, biData: biData, tabIndex: isOpen ? 0 : -1, className: s['button'] }, t(key))));
    })));
};
SubmitMenu.displayName = 'SubmitMenu';
export default SubmitMenu;
//# sourceMappingURL=SubmitMenu.js.map